
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"100%","height":"100%","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.9974 17.625H15.6178V13.8888C15.6178 12.997 15.6 11.8511 14.3794 11.8511C13.14 11.8511 12.9509 12.8216 12.9509 13.8235V17.625H10.5712V9.94142H12.8545V10.9906H12.8866C13.2052 10.3869 13.9823 9.75 15.1413 9.75C17.5522 9.75 17.9974 11.3413 17.9974 13.4111V17.625ZM7.80259 9C7.03542 9 6.41757 8.38425 6.41757 7.62456C6.41757 6.86575 7.03542 6.25 7.80259 6.25C8.56528 6.25 9.18671 6.86575 9.18671 7.62456C9.18671 8.38425 8.56528 9 7.80259 9ZM6.66931 17.625H9.06082V10H6.66931V17.625ZM19.1958 4H5.46558C4.81039 4 4.27783 4.51733 4.27783 5.15289V18.8462C4.27783 19.4844 4.81039 20 5.46558 20H19.1958C19.8519 20 20.3889 19.4844 20.3889 18.8462V5.15289C20.3889 4.51733 19.8519 4 19.1958 4Z","fill":"currentColor"}})])
          )
        }
      }
    